import React, { createContext, useContext, useEffect, useState } from 'react'
import { UserContext } from '../layouts/UserContext'

export const STANDARD_PRICE = { CAD: 4, USD: 3 }

const CurrencyContext = createContext({ currency: 'USD', selectCurrency: () => {} })

// Holds the selected currency so every pricing section shows the same prices.
// Defaults to CAD for visitors in Canada and USD for everyone else,
// until the visitor picks one from the dropdown.
export const CurrencyProvider = ({ children }) => {
    const location = useContext(UserContext)
    const [currency, setCurrency] = useState(location === 'CA' ? 'CAD' : 'USD')
    const [hasSelectedCurrency, setHasSelectedCurrency] = useState(false)

    useEffect(() => {
        if (!hasSelectedCurrency) {
            setCurrency(location === 'CA' ? 'CAD' : 'USD')
        }
    }, [location, hasSelectedCurrency])

    const selectCurrency = selectedCurrency => {
        setCurrency(selectedCurrency)
        setHasSelectedCurrency(true)
    }

    return (
        <CurrencyContext.Provider value={{ currency, selectCurrency }}>
            {children}
        </CurrencyContext.Provider>
    )
}

export const useCurrency = () => useContext(CurrencyContext)